(function() {
    'use strict';

    angular
        .module('elogbooks.common.quote-requests')
        .controller('CommonQuoteRequestDetailsQuoteDetailsController', CommonQuoteRequestDetailsQuoteDetailsController);

    CommonQuoteRequestDetailsQuoteDetailsController.$inject = [
        'quoteResponse',
        'quoteRequestResponse',
        'apiClient',
        'quoteLink',
        'linkedJobsCollectionResponse',
        '$state',
        'base64',
        'userManager'
    ];

    function CommonQuoteRequestDetailsQuoteDetailsController(
        quoteResponse,
        quoteRequestResponse,
        apiClient,
        quoteLink,
        linkedJobsCollectionResponse,
        $state,
        base64,
        userManager
    ) {
        var vm = this;
        vm.quoteResponse = quoteResponse;
        vm.quoteRequestResponse = quoteRequestResponse;
        vm.attributes = quoteResponse.attributes;
        vm.quoteLink = quoteLink;
        vm.linkedJobsCollection = linkedJobsCollectionResponse;
        vm.watchQuote = watchQuote;
        vm.unwatchQuote = unwatchQuote;
        vm.watchRequesting = false;
        vm.getUserHref = getUserHref;
        vm.canManageUsers = userManager.hasPermission(['user_permission_manage_users', 'user_permission_client_admin_manage_users']);

        function getUserHref(link) {
            return $state.href('dashboard.admin.users.list.details.info', { resource: base64.encode(link) });
        }
        vm.supportingDocsCount = vm.quoteResponse.filesCount;

        function watchQuote() {
            vm.watchRequesting = true;
            apiClient.create(vm.quoteResponse.getLink('watch-quote'), vm.quoteResponse).then((response) => {
                vm.quoteResponse.isQuoteWatched = response.isQuoteWatched;
                vm.watchRequesting = false;
            });
        }

        function unwatchQuote() {
            vm.watchRequesting = true;
            apiClient.delete(vm.quoteResponse.getLink('unwatch-quote')).then((response) => {
                vm.quoteResponse.isQuoteWatched = response.isQuoteWatched;
                vm.watchRequesting = false;
            });
        }
    }
})();
